import './static/css/toxic/font-estedad.css'
import './static/css/toxic/toxic.css';
import './static/css/open/open.css';
import './static/css/open/forms.css';
import './static/css/open/modals.css';
import './static/css/open/snackbar.css';
import './static/css/open/buttons.css';
import './static/css/open/table.css';
import './static/css/templ/main.css';
import './static/css/open/pages.css';
import './static/css/open/list-tile.css';
import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css';
import './static/css/override/datepicker.css';
import {App} from "./app";
import ReactDOM from 'react-dom/client';

const root = ReactDOM.createRoot(
    document.getElementById('rV01Bn') as HTMLElement
);
root.render(<App lang={'fa'} />);

setTimeout(() => {
  const l = document.querySelector('.mK76wQ');
  // @ts-ignore
  if (l!.style.display !== "none") {
    const span = document.querySelector('.M1r6j76 span');
    span!.innerHTML = 'این فرایند بیش از انتظار طول کشید.';
    span!.classList.add('f-roboto');
    const button = document.querySelector('.M1r6j76 button');
    button!.innerHTML = 'تلاش مجدد';
    button!.setAttribute('onclick', "window.location.reload();");
    let i = 0;
    const x = document.querySelector('.M1r6j76');
    //@ts-ignore
    x!.style.transform = 'scale(1)';
    const timerOpacity = setInterval(() => {
      i += 0.1;
      //@ts-ignore
      x!.style.opacity = i.toString();
      if (i > 0.9)
        clearInterval(timerOpacity);
    }, 70);
  }
}, 10000);